"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var NeutralDivider_1 = __importDefault(require("atomicComponents/atoms/Divider/NeutralDivider"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var HudledLogo_1 = __importDefault(require("components/modules/components/HudledLogo"));
var ShareWebLink_1 = __importDefault(require("containers/App/ShareWebLink"));
var PricingEstimateHeader = function (_a) {
    var quoteReport = _a.quoteReport, _b = _a.showButton, showButton = _b === void 0 ? false : _b;
    var theme = (0, material_1.useTheme)();
    var isSmallScreen = (0, material_1.useMediaQuery)(theme.breakpoints.down('md'));
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ pt: { xs: 1, md: 2 }, px: { xs: 4, md: 8 }, mx: "auto", maxWidth: 1000, width: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }, { children: [(0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: quoteReport.serviceData, size: isSmallScreen ? 'lg' : 'xl', fontWeight: "medium" }), showButton ? (0, jsx_runtime_1.jsx)(ShareWebLink_1.default, { quoteReport: quoteReport }) : (0, jsx_runtime_1.jsx)(HudledLogo_1.default, { height: isSmallScreen ? 24 : 32 })] })), (0, jsx_runtime_1.jsx)(NeutralDivider_1.default, {})] })));
};
exports.default = PricingEstimateHeader;
